import React from 'react';
import { Image, ImageBadge, ImageOverlay, StudyPlanButton, SvgIcon } from 'seduo-ui';
import AvatarPartnersExample from './AvatarPartner';
const Example = () => (<div className="card card-program h-100 shadow-sm" style={{
        maxWidth: '358px',
    }}>
        <ImageOverlay className="card-program__image-wrapper" topLeft={<>
                    <ImageBadge icon="education" text="Vzdělávací program" theme="dark" className="mb-5"/>
                    <br />
                    <ImageBadge text="Novinka" theme="dark"/>
                </>} topRight={<StudyPlanButton onAddToStudyPlan={() => { }} onRemoveFromStudyPlan={() => { }} title="Add to study plan"/>}>
            <a href="#" title="Bla bla">
                <Image src="https://dummyimage.com/520x350/9fa4a8/fff.png" alt="Bla bla" className="card-program__image"/>
            </a>
        </ImageOverlay>
        <div className="card-body card-program__body">
            <a className="card-program__title font-weight-medium" href="#" title="Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia.">
                <div className="text-truncate-multiline text-truncate-multiline-2">
                    <span>Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia.</span>
                </div>
            </a>
            <div className="card-program__subtitle card-program__subtitle--standalone">
                <div className="card-program__text">
                    <div className="text-truncate-multiline text-truncate-multiline-3">
                        <span title="Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Pellentesque arcu. Praesent dapibus.
              Pellentesque pretium lectus id turpis. Mauris dolor felis, sagittis at, luctus sed, aliquam non, tellus.">
                            Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Pellentesque arcu. Praesent
                            dapibus. Pellentesque pretium lectus id turpis. Mauris dolor felis, sagittis at, luctus sed,
                            aliquam non, tellus.
                        </span>
                    </div>
                </div>
            </div>
            <div className="card-program__subtitle card-program__subtitle--bottom">
                <div className="card-program__text">
                    <AvatarPartnersExample />
                </div>
                <div className="card-program__text pb-2">
                    <span className="mr-3">4 kurzy</span>
                    <span className="card-course__dote card-course__dote--gray card-course__dote--smaller mr-3"/>
                    <span>3h 45m</span>
                </div>
            </div>
        </div>
        <div className="card-program__footer">
            <div className="card-program__footer-wrapper justify-content-start align-items-center">
                <div className="card-course__text">
                    <span className="badge badge-light card-course__badge card-course__badge--rounded mr-6">
                        <SvgIcon kind="Trophy" className="card-program__icon"/>
                    </span>
                </div>
                <div className="card-course__text">
                    <div className="text-title">Po dokončení získáte odborný certifikát</div>
                </div>
            </div>
        </div>
    </div>);
export default Example;
